import axios from 'axios';
import { gql } from '@apollo/client';
import * as endpoints from './const';
// This has to change, cannot have manual routes inserted to acl in the UI -- sri --
import * as routes from '../routes/const';
// TODO remove this once above refactoring is done.
import {
  setAuthorizationToken,
  updateLocalStorage,
  updateLocalStorageTerms
} from '../auth/persistance';
import apolloClient from '../utils/apollo-client';

const legacyTokenMap = {
  businessEntity: 'BusinessEntity',
  countyCode: 'CountyCode',
  firstName: 'FirstName',
  lastName: 'LastName',
  userName: 'UserName',
  acceptTerms: 'accept_terms',
  accessToken: 'access_token',
  expiresIn: 'expires_in',
  tokenType: 'token_type',
  refreshToken: 'refresh_token',
  analyticsId: 'AnalyticsId',
  issued: '.issued',
  expires: '.expires'
};

const getUserRoutes = menus => {
  let children = [];
  let subroutes;

  const mainroutes = menus.map(item => {
    children = item.children ? children.concat(item.children) : children;
    return item.route;
  });

  mainroutes.push('fuel-cards');

  if (children.length > 0) subroutes = getUserRoutes(children);
  return mainroutes.concat(subroutes).filter(x => x);
};

// set axios auth header and store auth info in local storage
const setAuthInfo = data => {
  const {
    // eslint-disable-next-line camelcase
    accept_terms,
    access_token,
    refresh_token,
    UserName,
    FirstName,
    LastName,
    AnalyticsId,
  } = data;

  setAuthorizationToken(access_token);
  updateLocalStorageTerms(accept_terms);
  updateLocalStorage(
    access_token,
    refresh_token,
    UserName,
    FirstName,
    LastName,
    AnalyticsId,
  );

  return {
    username: UserName,
    firstName: FirstName,
    lastName: LastName,
    userMustAcceptTerms: accept_terms,
    refId: AnalyticsId
  };
};

const authErrHandler = error => {
  if (error.response && error.response.status === 400) {
    throw error;
  } else {
    return {
      connectionError: 'Please check your network connection and try again.'
    };
  }
};

class AuthApi {
  /**
   * log the user in and get a token
   *
   * @deprecated Use getLegacyToken
   */
  static getToken(username, password) {
    // eslint-disable-next-line no-console
    console.log('#### DO NOT CALL GET TOKEN #######');

    return axios({
      method: 'post',
      url: endpoints.AUTH_GET_TOKEN,
      data: `Username=${encodeURIComponent(
        username
      )}&password=${encodeURIComponent(password)}&Grant_type=password`,
      timeout: 15000,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
      .then(response => response.data)
      .then(setAuthInfo)
      .catch(authErrHandler);
  }

  static async getLegacyToken() {
    const client = await apolloClient();
    const response = await client.query({
      query: gql`
        query userGetLegacyToken {
          userGetLegacyToken {
            businessEntity
            countyCode
            firstName
            lastName
            userName
            acceptTerms
            accessToken
            expiresIn
            tokenType
            refreshToken
            analyticsId
            issued
            expires
          }
        }
      `,
      variables: {}
    });

    const { userGetLegacyToken: token } = response.data;
    const legacyToken = Object.entries(
      legacyTokenMap
    ).reduce((acc, [key, value]) => ({ ...acc, [value]: token[key] }));

    return setAuthInfo(legacyToken);
  }

  static getExternalToken(code) {
    return axios({
      method: 'post',
      url: endpoints.AUTH_GET_TOKEN,
      data: `code=${encodeURIComponent(code)}&Grant_type=external_auth`,
      timeout: 15000,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
      .then(response => response.data)
      .then(setAuthInfo)
      .catch(authErrHandler);
  }

  static getRefreshedToken(refreshToken) {
    return axios({
      method: 'post',
      url: endpoints.AUTH_GET_TOKEN,
      data: `refresh_token=${refreshToken}&grant_type=refresh_token`,
      timeout: 15000,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
      .then(response => response.data)
      .then(setAuthInfo)
      .catch(authErrHandler);
  }

  static async proxyGetView(roleId = '') {
    const client = await apolloClient();
    const response = await client.query({
      query: gql`
        query getActiveUserViewData($roleId: ID) {
          activeUserViewData(roleId: $roleId)
        }
      `,
      variables: {
        roleId
      }
    });

    return response.data;
  }

  /**
   * use the token to get globals / views the user has authorization for
   */
  static getView(id) {
    return this.proxyGetView(id)
      .then(response => {
        if (!response.activeUserViewData.viewData) {
          throw response.activeUserViewData;
        }
        const config = response.activeUserViewData.viewData.data;
        const defaultView = config.route.replace(':', '/');
        // This has to change, cannot have manual routes inserted to acl in the UI -- sri
        const defaultRoutes = [
          defaultView,
          routes.PROFILE,
          routes.MY_BOOKMARKS,
          routes.NOTIFICATION,
          routes.DASHBOARD_PROFILE.replace(
            '/:dashtype/:countryCode/:refid',
            ''
          ),
          routes.DASHBOARD_PROFILE_ID.replace(
            '/:dashtype/:countryCode/:refid',
            ''
          ),
          routes.REPORT_YELLOWFIN.replace('/:id', ''),
          routes.REPORT_POWERBI_EMBED.replace('/:embedtype/:id', ''),
          routes.SEARCH_RESULT,
          routes.CQ_MYQUOTE,
          routes.CQ_CREATE
        ];
        const userRoutes = getUserRoutes(config.menus);
        const acl = defaultRoutes.concat(userRoutes);

        return {
          defaultView,
          acl,
          success: true,
          BusinessEntityName: config.BusinessEntityName,
          menus: config.menus,
          filters: config.filters,
          tiles: config.tiles,
          home: config.title,
          icon: config.icon || null,
          homeRoute: config.route,
          hasServiceNow: config.accidentManagementFlag
        };
      })
      .catch(error => {
        if (error instanceof Error) {
          const result = {
            // Pull all enumerable properties, supporting properties on custom Errors
            ...error
          };
          throw result;
        }
        throw error;
      });
  }

  /**
   * send email to  the ForgotPassword endpoint to get the user and token for reeting the password
   */
  static forgotPassword(email) {
    return axios
      .post(endpoints.Forgot_Password, {
        email
      })
      .then(response => response.data)
      .then(data => {
        const { success, errors } = data;
        return {
          success,
          serverError: errors[0]
        };
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * send email and token to the ValidateResetPasswordToken endpoint to check the token validation
   * */
  static resetPasswordValidateToken(email, token) {
    return axios
      .post(endpoints.Validate_Reset_Token, {
        email,
        token
      })
      .then(response => response.data)
      .then(data => {
        const { success, errors } = data;
        return {
          success,
          serverError: errors[0]
        };
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * send email and token to the ResetPassword endpoint to change the password
   */
  static resetPassword(email, token, newPassword) {
    return axios
      .post(endpoints.Reset_Password, {
        email,
        token,
        newpassword: newPassword
      })
      .then(response => response.data)
      .then(data => {
        const { success, errors } = data;
        return {
          success,
          serverError: errors[0]
        };
      })
      .catch(error => {
        throw error;
      });
  }

  /**
   * logout the user, to expiry the usertoken on the serverside
   */
  static logout() {
    return axios
      .post(endpoints.LOGOUT_EXPIRE_TOKEN)
      .then(response => response.data)
      .then(data => {
        const { success, errors } = data;
        return {
          success,
          serverError: errors[0]
        };
      })
      .catch(error => {
        throw error;
      });
  }
}

export default AuthApi;



// WEBPACK FOOTER //
// ./src/api/AuthApi.js